export class RxListDto {
    Id: number;
    ClinicId: number;
    Code: string
    StdCode: string;
    RxCode: string;
    ATC: string;
    ProdName: string;
    UseUnit: string;
    DefaultDose: number;
    AllergyGroup: string;
    OrderType: number;
    OrderTypeName: string;
    IsStock: boolean;
}
